import axios from 'axios'
//import store from './index'
//let api = axios.create();
let api = axios;

//console.warn('refactor api, take token from user not local storage');
//console.warn('if failed due to user then could redirect to login page');

api.defaults.baseURL = globalApiUrl
// api.defaults.baseURL = 'https://api.memorywater.lv/api/v2'

// Add a request interceptor
api.interceptors.request.use(function(config) {
  // Add token
  if (localStorage.getItem("mw-token") != null && localStorage.getItem("mw-token") != '') {
    config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("mw-token");
  }
  return config;
}, function(error) {
  return Promise.reject(error);
});

api.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
    if (error.response != undefined) {
        if (error.response.data.error == "token_invalid" || error.response.data.error == "token_not_provided") {
            localStorage.removeItem("mw-token");
            //document.location.href="/login";
        }
    }
    // Do something with response error
    return Promise.reject(error);
});

// Add a response interceptor
/*
api.interceptors.response.use(function(response) {
  return Promise.resolve(response);
}, function(error) {
  // Do something with response error
  return Promise.reject(error);
});
*/

export default api


// WEBPACK FOOTER //
// ./src/store/api.js